<div class="nudgeContainer">
  <div *ngIf="!user?.listsubscriptions?.medical" class="sipPitchSection" (click)="trackButton()">
    <div class="img"><img loading="lazy" data-src="/assets/images/poor-kids.png" alt="kids"></div>
    <div class="desc">
      <div class="subTitle">What’s better than saving one child?</div>
      <div class="title">Saving 12 more!</div>
      <div class="actBtn"><button mat-raised-button>Start monthly giving</button></div>
    </div>
  </div>
  <div *ngIf="user?.listsubscriptions?.medical" class="viewFundraisers">
    <div class="title">View fundraisers you have supported</div>
    <div class="actBtn"><button (click)="checkForLogin(loginPopupTemp)" mat-button>Click here</button></div>
  </div>
  <div class="contactus">
    <div class="title">Confused about how to start a fundraiser?</div>
    <div class="actBtn"><button (click)="openDialogTalkToUs()" mat-button>Talk to Us</button></div>
  </div>
</div>

<!-- <div class="widget-insertions">
  <div class="view-fundraisers-container" *ngIf="!user?.listsubscriptions?.medical">
    <div class="view-fundraisers" (click)="trackButton()">
      <div class="img-girls"><img loading="lazy" data-src="/assets/images/Sip-banner-people/girls-sip.png" srcset="">
      </div>
      <div class="text">
        <div class="subtext">What’s Better Than <span>Saving One Child?</span></div>
        <div class="heading">Saving 12 More!</div>
        <button mat-raised-button>Start Giving Monthly</button>
      </div>
    </div>
  </div>
  <div class="view-fundraisers-container-v2 col-lg-7 col-md-7" *ngIf="user?.listsubscriptions?.medical">
    <div class="view-fundraisers-v2">
      <div class="text-v2">View fundraisers you have supported on Ketto</div>
      <button class="view-button-v2" (click)="checkForLogin(loginPopupTemp)" mat-button><span class="link">Click
          here</span> </button>
    </div>
  </div>
  <div class="search-fundraisers-container">
    <div class="search-fundraisers ">
      <div class="text">Confused about how to start a Fundraiser?</div>
      <button class="search-button" (click)="openDialogTalkToUs()" mat-button>Talk to us</button>
    </div>
  </div>
</div> -->
<!-- Old SIp Nudge -->

<ng-template #loginPopupTemp>
  <app-module-loader moduleId="login-popup" selector="app-login-popup" [load]="true"></app-module-loader>
</ng-template>